// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__Ev9Wo","col":"Table_col__30XV4","inactiveCol":"Table_inactiveCol__R9o75","buttonCol":"Table_buttonCol__2XcM2","row":"Table_row__g7aw6"};